import { useCallback } from "react";
import { DiceIcon } from "@/shared/icons";
import CreateCharacterBtn from "@/domains/createCharacter/components/CreateCharacterBtn";

type Props = {
  onClick: (value: number | string) => void;
  variants?: (number | string)[];
  returnIndex?: boolean;
};

export default function CreateCharacterBtnRandom({ onClick, variants, returnIndex }: Props) {
  const chooseRandom = useCallback(() => {
    const randomIndex = Math.floor(Math.random() * variants.length);
    const randomValue = variants[randomIndex];
    onClick(returnIndex ? randomIndex : randomValue);
  }, [onClick, variants, returnIndex]);

  return (
    <CreateCharacterBtn onClick={variants ? chooseRandom : () => onClick("")}>
      <DiceIcon size={20} className="-scale-x-100" />
    </CreateCharacterBtn>
  );
}
